// extracted by mini-css-extract-plugin
export var layout = "style-module--layout--1jqA2";
export var body = "style-module--body--1Zyap";
export var menu = "style-module--menu--214Y1";
export var content = "style-module--content--384S4";